import { memo } from "react";

import { Button } from "@/components/ui/button";
import type { AiSuggestedQuery } from "@/feature/ai-planner/types/ai-chat.types";
import { cn } from "@/lib/utils";

export const SuggestedQueryChips = memo(function SuggestedQueryChips({
  queries,
  onSelect,
  disabled = false,
  pendingQueryId,
}: {
  queries?: readonly AiSuggestedQuery[];
  onSelect?: (query: AiSuggestedQuery) => void;
  disabled?: boolean;
  pendingQueryId?: string | null;
}) {
  if (!queries?.length || !onSelect) {
    return null;
  }

  const visibleQuery = queries.at(-1);
  if (!visibleQuery) {
    return null;
  }

  return (
    <div className="animate-in fade-in-0 slide-in-from-bottom-2 mb-3 flex flex-wrap gap-2 duration-300">
      <Button
        key={visibleQuery.id}
        type="button"
        size="sm"
        variant="outline"
        disabled={disabled || pendingQueryId === visibleQuery.id}
        className={cn(
          "animate-in fade-in-0 zoom-in-95 h-auto max-w-full rounded-full border-border/70 bg-background/80 px-3 py-1.5 text-left text-xs font-medium whitespace-normal shadow-none duration-200 hover:bg-muted/70",
          pendingQueryId === visibleQuery.id &&
            "border-primary/30 text-muted-foreground",
        )}
        onClick={() => onSelect(visibleQuery)}
      >
        {pendingQueryId === visibleQuery.id ? "Sending..." : visibleQuery.label}
      </Button>
    </div>
  );
});
